export default __webpack_public_path__ + "static/rsz_olena_stukanova_olena_stukanova-16be7f03eca5b7d0638397b53f72742e.jpg";